// extracted by mini-css-extract-plugin
export default {"type":"CardProductCell_type__evAxL","wrapper":"CardProductCell_wrapper__wJ0HA"};